export default {"src":"/_next/static/media/SubDesc1.bc058cb6.svg","height":131,"width":128,"blurWidth":0,"blurHeight":0};